import type from './DPP.type';

const initialState = {
  dppLibraryDetail: null,
  dppList: [],
};

const poTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_DPP_DATA_BYID:
      return {
        ...state,
        dppLibraryDetail: action.payload,
      };
    case type.GET_ALL_DPP_LIST:
      return {
        ...state,
        dppList: action.payload,
      };
    case type.UNMOUNT_DPP_LIST:
      return {
        ...state,
        dppList: [],
      };
    case type.UNMOUNT_DPP_LIBRARY:
      return {
        ...state,
        dppLibraryDetail: null,
      };

    default:
      return state;
  }
};

export default poTemplateReducer;
